import React, { useCallback, useContext } from 'react'

import { TabsContext } from '../../../contexts/tabs'

import * as S from './styles'

export const Paginate = () => {
  const { currentIndex, isCurrentTab, isDisabled, onGotoTab, props } =
    useContext(TabsContext)

  const isVisiblePage = useCallback(
    (index: number) => {
      let visibleIndexes = []
      if (currentIndex === 0) {
        visibleIndexes = [0, 1, 2]
      } else if (currentIndex === props.render.length - 1) {
        visibleIndexes = [currentIndex, currentIndex - 1, currentIndex - 2]
      } else {
        visibleIndexes = [currentIndex, currentIndex - 1, currentIndex + 1]
      }

      return visibleIndexes.includes(index)
    },
    [currentIndex, props.render.length]
  )

  const renderPaginate = () => {
    return props.render.map(
      ({ disabled, status }, index) =>
        isVisiblePage(index) && (
          <S.Foot
            {...{
              key: index,
              className: `tabs-foot ${isCurrentTab(currentIndex, index)} ${
                status || ''
              } ${isDisabled(disabled)}`,
              onClick: () => {
                onGotoTab(index)
              }
            }}
          >
            <span>{index + 1}</span>
          </S.Foot>
        )
    )
  }

  return <S.Footer>{renderPaginate()}</S.Footer>
}
